import styled from "styled-components";

export const ClockInOutTableHeader = styled.div`
  display: grid;
  grid-template-columns: 220px 80px 140px 100px 100px 150px 250px 1fr;
  grid-column-gap: 20px;
  justify-content: start;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  /* @media (max-width: 1250px) {
    grid-template-columns: 250px 200px 200px 150px;
    grid-column-gap: 10px;
  } */
`;

export const ClockInOutTableMainRow = styled.div`
  display: grid;
  grid-template-columns: 220px 80px 140px 100px 100px 150px 250px 1fr;
  grid-column-gap: 20px;
  justify-content: start;
  padding: 0 20px;
  // :nth-of-type(even) {
  //   background-color: #f8f9fc;
  // }
  &:hover {
    background-color: ${({ theme }) => theme.colors.hover.tableHover};
  }
  @media (max-width: 1250px) {
    /* grid-template-columns: 250px 200px 200px 150px; */
  }
`;

export const ClockInOutTableRow = styled.div`
  display: grid;
  grid-template-columns: 220px 80px 140px 100px 100px 150px 250px 1fr;
  grid-column-gap: 20px;
  justify-content: start;
  padding: 0 20px;
  :nth-of-type(even) {
    background-color: #f8f9fc;
  }
  @media (max-width: 1250px) {
    /* grid-template-columns: 250px 200px 200px 150px; */
  }
`;
export const ClockInOutTableHeaderNew = styled.div`
  display: grid;
  grid-template-columns: 200px 300px;
  grid-column-gap: 20px;
  justify-content: start;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  /* @media (max-width: 1250px) {
    grid-template-columns: 250px 200px 200px 150px;
    grid-column-gap: 10px;
  } */
`;

const colteredTextColor = {
  "visited_another_camp": "#0D9488",
  "clock_out_due_to_time": "#DC2626",
  "emergency_leave": "#D97706",
  "end_of_shift": "#16A34A",
  "normal": "#16A34A",
};

export const ColoredTextWithValue = styled.span`
  color: ${({ reason }) => colteredTextColor[reason] || "#16A34A"};
  font-weight: 500;
  font-size: 14px;
`;